import { useEffect, RefObject, DependencyList } from 'react'

/* How to use:
 * import useOutsideClickHandler from 'hooks/outsideClickHandler'
 * useOutsideClickHandler(
 *  [firstRef, secondRef],
 *  clickHandler,
 *  [clickHandlerDependencies]
 * )
*/
const useOutsideClickHandler = (
  refs: RefObject<HTMLElement>[],
  callback: (event: Event) => void,
  dependencies: DependencyList = [],
) => {
  useEffect(() => {
    const clickHandler = (event: Event) => {
      const isOutside = refs.every((ref) => !ref.current?.contains(event.target as Node))

      if (isOutside) {
        callback(event)
      }
    }

    document.addEventListener('click', clickHandler)

    return () => document.removeEventListener('click', clickHandler)
  }, [callback, ...dependencies, ...refs])
}

export default useOutsideClickHandler
